module.exports = __webpack_public_path__ + "static/logo-41d444ba79b4ff3ecf6529024d86a234.png";